<div class="pf">
  <p class="pf-hint">All optional — anything left empty is simply not shown on the property page.</p>

  <div class="pf-grid">
    <label class="pf-field" *ngIf="asksLand">
      <span>Land area (m²)</span>
      <input class="pf-input" type="number" min="0" [(ngModel)]="form.land_size" name="land_size" placeholder="400" />
    </label>
    <label class="pf-field" *ngIf="asksGardenChoice">
      <span>Ground floor with a garden?</span>
      <select class="pf-input" [(ngModel)]="form.has_garden" (ngModelChange)="onGardenChoice()" name="has_garden">
        <option [ngValue]="null">Not said</option>
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </label>
    <label class="pf-field" *ngIf="showGardenSize">
      <span>Garden (m²)</span>
      <input class="pf-input" type="number" min="0" [(ngModel)]="form.garden_size" name="garden_size" placeholder="46" />
    </label>
    <label class="pf-field" *ngIf="asksOutdoor">
      <span>Outdoor area?</span>
      <select class="pf-input" [(ngModel)]="form.has_outdoor" (ngModelChange)="onOutdoorChoice()" name="has_outdoor">
        <option [ngValue]="null">Not said</option>
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </label>
    <label class="pf-field" *ngIf="asksOutdoor && form.has_outdoor === true">
      <span>Outdoor area (m²)</span>
      <input class="pf-input" type="number" min="0" [(ngModel)]="form.outdoor_size" name="outdoor_size" placeholder="30" />
    </label>
    <label class="pf-field">
      <span>Level (English)</span>
      <input class="pf-input" type="text" maxlength="100" [(ngModel)]="form.level_en" name="level_en" placeholder="Ground" />
    </label>
    <label class="pf-field">
      <span>Level (Arabic)</span>
      <input class="pf-input" type="text" maxlength="100" dir="rtl" [(ngModel)]="form.level_ar" name="level_ar" placeholder="أرضي" />
    </label>
    <div class="pf-field pf-span-all">
      <div class="pf-translate-row">
        <button type="button" class="pf-btn-translate"
          (click)="translateLevelToAr()"
          [disabled]="translatingLevel.toAr || !form.level_en?.trim()">
          <span *ngIf="!translatingLevel.toAr">← Translate EN to AR</span>
          <span *ngIf="translatingLevel.toAr" class="pf-spinner-xs"></span>
        </button>
        <button type="button" class="pf-btn-translate"
          (click)="translateLevelToEn()"
          [disabled]="translatingLevel.toEn || !form.level_ar?.trim()">
          <span *ngIf="!translatingLevel.toEn">Translate AR to EN →</span>
          <span *ngIf="translatingLevel.toEn" class="pf-spinner-xs"></span>
        </button>
      </div>
      <p class="pf-translate-error" *ngIf="levelTranslateError">Translation failed — please try again.</p>
    </div>
    <label class="pf-field">
      <span>Maintenance (English)</span>
      <input class="pf-input" type="text" maxlength="255" [(ngModel)]="form.maintenance_en" name="maintenance_en" placeholder="8% on delivery" />
    </label>
    <label class="pf-field">
      <span>Maintenance (Arabic)</span>
      <input class="pf-input" type="text" maxlength="255" dir="rtl" [(ngModel)]="form.maintenance_ar" name="maintenance_ar" placeholder="٨٪ عند التسليم" />
    </label>
  </div>

  <div class="pf-block">
    <label class="pf-label">Floor plan</label>
    <app-media-uploader folder="properties" [multiple]="false" (uploaded)="onPlan($event)"></app-media-uploader>
    <input class="pf-input" type="text" [(ngModel)]="form.floor_plan" name="floor_plan" placeholder="or paste URL" />
    <img class="pf-preview" *ngIf="form.floor_plan" [src]="form.floor_plan" alt="floor plan preview" />
  </div>
</div>
